import React from "react";
import "./aboutDesktop.css";
export const AboutStudio = () => {
  return (
    <div className="about-section" id="about">
      <h2 className="about-title">Про нас</h2>
      <div className="team-container">
        <h3 className="team-subtitle">Живопис</h3>
        <p>
          Займатись мистецтвом - це унікальний спосіб самовираження та відкриття
          свого творчого потенціалу. Писати на холсті акриловими фарбами та
          гуашшю - дозволяє зануритись у світ кольорів і форм, звільняючи
          внутрішній світ і знаходячи натхнення у навколишньому. Кожна кисточка
          стає вашим магічним інструментом, який допомагає передати ваші думки
          та почуття на полотні, створюючи творіння мистецтва, яке залишає вас
          задоволеними та захопленими.
        </p>
        <h3 className="team-subtitle">Гончарство</h3>
        <p>
          Гончарство - це захоплююче ремесло, яке дозволяє працювати з глиною та
          створювати унікальні вироби. Кожен виріб отримується унікальним
          завдяки рукам талановитих майстрів, які знають секрети обробки глини
          та виготовлення чудових форм. Займаючись гончарством, ви зможете
          втілити свою творчість у реальність і створити неповторні вироби, які
          прикрасять ваш дім або стануть чудовими подарунками для рідних та
          друзів.
        </p>
        <h3 className="team-subtitle">Наша команда</h3>
        <p>
          Наша команда - це злагоджена група професіоналів, яка пристрасно
          ставиться до мистецтва та гончарства. Ми з радістю поділимося своїм
          досвідом та знаннями з вами, навчимо вас основам мистецтва та
          допоможемо розвинути ваші таланти. Приєднуйтесь до нас і відкрийте для
          себе захоплюючий світ творчості!
        </p>
        <h3 className="team-subtitle">Чому обрати саме нашу студію ?</h3>
        <p>
          Вибір нашої студії - це вибір професіоналів, які дбають про ваші
          творчі досягнення. Ми пропонуємо індивідуальний підхід до кожного
          учня, допомагаємо розвивати ваш талант та підкреслити ваш унікальний
          стиль. Наші вчителі - це досвідчені майстри, які поділяться з вами
          своїми знаннями і вміннями. Ми створимо теплу та творчу атмосферу, де
          ви зможете зануритися у світ мистецтва та гончарства. Приходьте до нас
          та відкрийте для себе чудовий світ творчості та мистецтва!
        </p>
      </div>
    </div>
  );
};
